import initIframe from './iframe';

document.querySelectorAll('.video[data-url]')
  .forEach($video => initIframe($video));
